'use strict';
/**
 * @author Björn "Empu" Schädel
 */
function FlyoutController() {

    var self = this,
        arrFlyouts = [];

    /**
     * @type null
     */
    this.autoCloseTimeout = undefined;

    /**
     * @type {number}
     */
    this.autoCloseTime = 3000; // in ms

    /**
     *
     * @type {number}
     */
    this.scrollTimeOut = 250; // in ms

    /**
     * @type {number}
     */
    this.offsetTop = 30;

    /**
     * initialize Flyouts
     */
    function init() {
        var $flyouts = $('.flyout');

        if ($flyouts.length > 0) {
            $flyouts.each(function () {
                arrFlyouts.push($(this).attr('id'));

                if ($(this).hasClass('flyout-force')) {
                    self._show($(this).attr('id'));

                    // if flyout has autoclose, call autoclose
                    if ($(this).hasClass('flyout-autoclose')) {
                        var timeout = $(this).is('[data-flyout-timeout]') ? parseInt($(this).data('flyout-timeout')) : 0;

                        if (timeout === 0) {
                            timeout = self.autoCloseTime;
                        }

                        self.autoCloseTimeout = window.setTimeout(self._autoClose, timeout);
                    }
                }
            });
        }
    }

    /**
     * callback method to handle auto close flyout
     *
     * @private
     */
    this._autoClose = function () {

        // remove active state from buttons
        $('.flyout-active').each(function () {
            $(this).removeClass('flyout-active');
        });

        // remove window click listener
        $(window).off('click');

        // close all
        self._closeAll();
    };

    /**
     * all registered flyouts will be closed, resets autoCloseTimeout
     *
     * @private
     */
    this._closeAll = function () {
        // clear timeout if set
        if (typeof this.autoCloseTimeout === 'number') {
            window.clearTimeout(this.autoCloseTimeout);
            this.autoCloseTimeout = undefined;
            // remove window scroll listener
            $(window).off('scroll');
        }

        $.each(arrFlyouts, function (i, e) {
            $('#' + e).hide();
        });
    };

    /**
     * methods checks if a given id is a registered flyout
     *
     * @param {string} id
     * @returns {boolean}
     * @private
     */
    this._checkFlyoutId = function (id) {
        return (typeof id === 'string' && id.length > 0 && (arrFlyouts.indexOf(id) !== -1));
    };


    /**
     *
     * @param {object} $flyout
     * @returns {boolean}
     * @private
     */
    this._checkFlyoutForScrollHandling = function ($flyout) {
        var check = false;

        if (typeof $flyout === 'object' && $flyout.hasClass('flyout-ignore-scroll')) {
            var maxWidth = $flyout.is('[data-flyout-ignore-max-width]') ? parseInt($flyout.data('flyout-ignore-max-width')) : 0;
            if (maxWidth === 0 || this._getWindowWith() <= maxWidth) {
                check = true;
            }
        }

        return check;
    };

    /**
     *
     * @param {string} id
     * @param {object} $element
     * @private
     */
    this._show = function (id, $element) {
        var $flyout = $('#' + id);

        if (typeof $element === 'object') {

            this._closeAll();

            if ($element.hasClass('flyout-active')) {
                $element.removeClass('flyout-active');
                $(window).off('click');
            } else {
                $('.flyout-active').each(function () {
                    $(this).removeClass('flyout-active');
                });

                $element.addClass('flyout-active');
                $flyout.show();

                $(window).click(function (event) {
                    if ($flyout.has(event.target).length === 0 && $element.has(event.target).length === 0) {
                        $element.removeClass('flyout-active');
                        $flyout.hide();
                        $(window).off('click');
                    }
                });

                if (!this._checkFlyoutForScrollHandling($flyout)) {
                    this._registerWindowScrollEvent();
                }
            }
        } else {
            $element = $('[data-flyout="' + id + '"]');
            this._show($element.data('flyout'), $element);
        }
    };

    /**
     * method to register events
     *
     * @private
     */
    this._registerWindowScrollEvent = function () {

        $(window).scroll(function () {
            if (window.pageYOffset >= self.offsetTop) {
                window.setTimeout(function () {
                    // if autoclose timeout is set, scroll event will not close the flyout
                    if (typeof self.autoCloseTimeout !== 'number') {
                        self._autoClose();
                    }
                }, self.scrollTimeOut);
            }
        });
    };

    /**
     *
     * @returns {number}
     * @private
     */
    this._getWindowWith = function () {
        return $(window).width();
    };

    /**
     *
     * @param {object} event
     * @param element
     */
    this.toggle = function (event, element) {
        event.stopPropagation();

        if (typeof element !== 'undefined') {

            var $element = $(element),
                id = $element.data('flyout');

            if (this._checkFlyoutId(id) !== false) {
                this._show(id, $element);
            }
        }

    };

    /**
     *
     * @param {object} event
     * @param {string} id
     */
    this.show = function (event, id) {
        event.stopPropagation();
        this._show(id);
    };

    init();
}

var flyout;

$(function () {
    flyout = new FlyoutController();
});
